import { IAncillaryMeeting } from '@/Models/IAncillaryMeeting';
import { ITypedValidationResult } from '@/Models/IValidationResult';
import { BaseApiService } from './base-api-service';

class ancillaryMeetingService extends BaseApiService {
    public constructor() {
		super('ancillaryMeeting/');
    }

	public async getByPhaseId(phaseId: number): Promise<IAncillaryMeeting[]> {
		return this.httpClient.get<IAncillaryMeeting[]>(`GetByPhaseId/${phaseId}`).then(this.handleResponse.bind(this)).catch(this.handleError.bind(this));
    }
    
	public async save(dto: IAncillaryMeeting): Promise<ITypedValidationResult<IAncillaryMeeting>> {
		return this.httpClient.post<ITypedValidationResult<IAncillaryMeeting>>("save", dto).then(this.handleResponse.bind(this)).catch(this.handleError.bind(this));
	}

	public async delete(id: number): Promise<void> {
		return this.httpClient.delete<void>(`delete/${id}`).then(this.handleResponse.bind(this)).catch(this.handleError.bind(this));
	}
}

export const AncillaryMeetingService: ancillaryMeetingService = new ancillaryMeetingService();